import { render, staticRenderFns } from "./ItemFilters.vue?vue&type=template&id=4f42320d&scoped=true&"
import script from "./ItemFilters.vue?vue&type=script&lang=js&"
export * from "./ItemFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f42320d",
  null
  
)

export default component.exports